import { Link } from "react-router-dom";
import { useApi } from "../app/ApiContext";
import { LEAGUE_ID } from "../app/config";
import { useSettings, useStandings } from "../data";
import "./YourTeamCard.css";

/** Sidebar card naming the viewer's team and its league position. */
export const YourTeamCard = () => {
	const { myEntryId } = useSettings();
	const api = useApi();
	const { standings } = useStandings(api, LEAGUE_ID);
	const mine = standings.find((s) => s.entry === myEntryId);

	if (myEntryId == null) {
		return (
			<Link to="/settings" className="your-team card">
				<div className="your-team-label">Your team</div>
				<div className="your-team-name">Not set</div>
				<div className="your-team-meta">Choose in settings</div>
			</Link>
		);
	}

	return (
		<Link to="/settings" className="your-team card">
			<div className="your-team-label">Your team</div>
			<div className="your-team-name">{mine?.entry_name ?? "…"}</div>
			<div className="your-team-meta">{mine ? `Rank ${mine.rank} · ${mine.total} pts` : " "}</div>
		</Link>
	);
};
